import {createAction, handleActions} from 'redux-actions';
import {Api} from '../../api/api';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from '../common/submitForm';
import _ from 'lodash';
import moment from 'moment';
import {logout, onForbidden} from '../account/login';
import {getCurrentGroup} from "../account/role";
import {fetchGetRejectedAccreditationsNotifications} from "../common/notifications";
import {getContinentByCountry, getLocationData} from '../common/location';

export const REJECTED_BY_VALIDATORS = "REJECTED_BY_VALIDATORS";
export const REJECTED_BY_APPLICANTS = "REJECTED_BY_APPLICANTS";

//- Actions
export const resetAccreditationListData = createAction('ACCREDITATION_GROUP_LIST_RESET');
export const onSetStartAccreditation = createAction('SET_START_ACCREDITATION');
export const setStartAccreditation = (id) => (dispatch, getState) => {
    let index = getAccreditationIndexById(getState(), id);
    dispatch(onSetStartAccreditation(index));
    dispatch(cleanValidatedStatus());
};
export const cleanStartAccreditation = createAction('CLEAN_START_ACCREDITATION');
export const onSetNextAsStartAccreditation = createAction('SET_NEXT_AS_START_ACCREDITATION');
export const setNextAsStartAccreditationForValidation = () => (dispatch, getState) => {
    let list = getAccreditationsData(getState());
    let currentPage = getCurrentPageForAccreditationsList(getState());
    let groupId = getCurrentGroup(getState());

    if (!_.isNil(list) && list.length > 0) {
        let currentIndex = getCurrentAccreditationIndex(getState());
        if (currentIndex < list.length - 1) {
            dispatch(onSetNextAsStartAccreditation(currentIndex + 1));
            dispatch(getAccreditationForValidation(groupId, currentPage));
        } else {
            let totalPages = getTotalPagesForAccreditationsList(getState());
            if (currentPage < totalPages - 1) {
                dispatch(onSetNextAsStartAccreditation(0));
                dispatch(getAccreditationForValidation(groupId, currentPage + 1));
            } else {
                dispatch(cleanStartAccreditation());
            }
        }
    }
};

export const setNextAsStartAccreditationForReview = () => (dispatch, getState) => {
    let list = getAccreditationsData(getState());
    let currentPage = getCurrentPageForAccreditationsList(getState());
    let groupId = getCurrentGroup(getState());

    if (!_.isNil(list) && list.length > 0) {
        let currentIndex = getCurrentAccreditationIndex(getState());
        if (currentIndex < list.length - 1) {
            dispatch(onSetNextAsStartAccreditation(currentIndex + 1));
            dispatch(getAccreditationForReview(groupId, currentPage));
        } else {
            let totalPages = getTotalPagesForAccreditationsList(getState());
            if (currentPage < totalPages - 1) {
                dispatch(onSetNextAsStartAccreditation(0));
                dispatch(getAccreditationForReview(groupId, currentPage + 1));
            } else {
                dispatch(cleanStartAccreditation());
            }
        }
    }
};

export const cleanValidatedStatus = createAction('CLEAN_VALIDATED_STATUS');
export const incrementNumberOfValidatedAccreditations = createAction('NUMBER_OF_VALIDATED_ACCREDITATIONS_INCREMENT');

export const fetchGetAccreditationsFailed = createAction('FETCH_GET_ACCREDITATIONS_FAILED');
export const fetchGetAccreditationsSuccess = createAction('FETCH_GET_ACCREDITATIONS_SUCCESS');

export const getAccreditationForValidation = (group, page) => (dispatch, getState) => {
    if (!_.isNil(group)) {
        let countryFilter = getAccreditationsCountryFilter(getState());
        let domainFilter = getAccreditationsDomainFilter(getState());
        dispatch(fetchGetAccreditationsForValidation(group, countryFilter, domainFilter, page));
    }
};

export const fetchGetAccreditationsForValidation = createAction(
    'FETCH_GET_ACCREDITATIONS',
    (groupId, countryFilter, domainFilter, page) => Api.getAccreditationsForValidation(groupId, countryFilter, domainFilter, page),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationsSuccess,
        onFail: fetchGetAccreditationsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setRejectedBy = createAction('REJECTED_BY_SET');

export const getAccreditationForReview = (group, page) => (dispatch, getState) => {
    let rejectedBy = getRejectedBy(getState());

    switch (rejectedBy) {
        case REJECTED_BY_VALIDATORS:
            dispatch(getRejectedByValidatorsAccreditations(group, page));
            break;
        case REJECTED_BY_APPLICANTS:
            dispatch(getRejectedByApplicantsAccreditations(group, page));
            break;
        default:
            break;
    }
};

export const getRejectedByValidatorsAccreditations = (group, page) => (dispatch, getState) => {
    if (!_.isNil(group)) {
        let countryFilter = getAccreditationsCountryFilter(getState());
        let domainFilter = getAccreditationsDomainFilter(getState());
        dispatch(fetchGetAccreditationsForReview(group, page, true, countryFilter, domainFilter));
    }
};

export const getRejectedByApplicantsAccreditations = (group, page) => (dispatch, getState) => {
    if (!_.isNil(group)) {
        let countryFilter = getAccreditationsCountryFilter(getState());
        let domainFilter = getAccreditationsDomainFilter(getState());
        dispatch(fetchGetAccreditationsForReview(group, page, false, countryFilter, domainFilter));
    }
};

export const fetchGetAccreditationsForReview = createAction(
    'FETCH_GET_ACCREDITATIONS',
    (groupId, page, isInternal, countryFilter, domainFilter) => Api.getAccreditationsForReviewByGroupId(groupId, page, isInternal, countryFilter, domainFilter),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationsSuccess,
        onFail: fetchGetAccreditationsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onInsertAccreditation = createAction(
    'FETCH_INSERT_ACCREDITATION',
    (data) => Api.insertAccreditation(data),
    () => ({
        apiCall: true,
        onSuccess: fetchSubmitFormSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchInsertAccreditation = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onInsertAccreditation(data));
};


export const onValidateAccreditationSuccess = () => (dispatch, getState) => {
    dispatch(fetchSubmitFormSuccess());
    let currentPage = getCurrentPageForAccreditationsList(getState());
    let groupId = getCurrentGroup(getState());
    dispatch(getAccreditationForValidation(groupId, currentPage));
    dispatch(incrementNumberOfValidatedAccreditations());
};
export const onValidateAccreditation = createAction(
    'FETCH_VALIDATE_ACCREDITATION',
    (accreditationId, data) => Api.validateAccreditation(accreditationId, data),
    () => ({
        apiCall: true,
        onSuccess: onValidateAccreditationSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchValidateAccreditation = (accreditationId, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onValidateAccreditation(accreditationId, data));
};

export const onReviewAccreditationSuccess = () => (dispatch, getState) => {
    dispatch(fetchSubmitFormSuccess());
    let currentPage = getCurrentPageForAccreditationsList(getState());
    let groupId = getCurrentGroup(getState());
    dispatch(getAccreditationForReview(groupId, currentPage));
    dispatch(incrementNumberOfValidatedAccreditations());
};
export const onReviewAccreditation = createAction(
    'FETCH_REVIEW_ACCREDITATION',
    (accreditationId, data) => Api.reviewAccreditation(accreditationId, data),
    () => ({
        apiCall: true,
        onSuccess: onReviewAccreditationSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchReviewAccreditation = (accreditationId, data) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onReviewAccreditation(accreditationId, data));
};

export const onRemoveAccreditationSuccess = () => (dispatch, getState) => {
    let currentPage = getCurrentPageForAccreditationsList(getState());
    let groupId = getCurrentGroup(getState());
    dispatch(fetchGetRejectedAccreditationsNotifications(groupId));
    dispatch(getAccreditationForReview(groupId, currentPage));
};
export const fetchRemoveAccreditation = createAction(
    'FETCH_REMOVE_ACCREDITATION',
    (accreditationId) => Api.removeAccreditation(accreditationId),
    () => ({
        apiCall: true,
        onSuccess: onRemoveAccreditationSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetManagedOrgsSuccess = createAction('FETCH_GET_MANAGED_ORGS_SUCCESS');
export const fetchGetManagedOrgsFailed = createAction('FETCH_GET_MANAGED_ORGS_FAILED');
export const fetchGetManagedOrgs = createAction(
    'FETCH_GET_MANAGED_ORGS',
    (countryCode) => Api.getManagedOrgs(countryCode),
    () => ({
        apiCall: true,
        onSuccess: fetchGetManagedOrgsSuccess,
        onFail: fetchGetManagedOrgsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const clearManagedOrgs = createAction('CLEAR_MANAGED_ORGS');

export const fetchGetAccreditationsPerCountryFailed = createAction('FETCH_GET_ACCREDITATIONS_PER_COUNTRY_FAILED');
export const fetchGetAccreditationsPerCountrySuccess = createAction('FETCH_GET_ACCREDITATIONS_PER_COUNTRY_SUCCESS');
export const fetchGetAccreditationsPerCountryForValidation = createAction(
    'FETCH_GET_ACCREDITATIONS_PER_COUNTRY',
    (groupId) => Api.getStaticsticsForAccreditationsForValidation(groupId),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationsPerCountrySuccess,
        onFail: fetchGetAccreditationsPerCountryFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetAccreditationsPerCountryRejectedByValidators = createAction(
    'FETCH_GET_ACCREDITATIONS_PER_COUNTRY',
    (groupId) => Api.getStatisticsForRejectedAccreditations(groupId, true),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationsPerCountrySuccess,
        onFail: fetchGetAccreditationsPerCountryFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetAccreditationsPerCountryRejectedByApplicants = createAction(
    'FETCH_GET_ACCREDITATIONS_PER_COUNTRY',
    (groupId) => Api.getStatisticsForRejectedAccreditations(groupId, false),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationsPerCountrySuccess,
        onFail: fetchGetAccreditationsPerCountryFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setAccreditationsCountryFilter = createAction('SET_ACCREDITATIONS_COUNTRY_FILTER');
export const clearAccreditationsCountryFilter = createAction('CLEAR_ACCREDITATIONS_COUNTRY_FILTER');
export const onUpdateAccreditationsCountryFilterForValidation = (countryFilter) => (dispatch, getState) => {
    dispatch(setAccreditationsCountryFilter(countryFilter))
    let groupId = getCurrentGroup(getState());
    dispatch(fetchGetAccreditationsForValidation(groupId, countryFilter));
    dispatch(fetchGetAccreditationsPerDomainForValidation(groupId, countryFilter));
    dispatch(clearAccreditationsDomainFilter());
}
export const onUpdateAccreditationsCountryFilterRejectedByValidators = (countryFilter) => (dispatch, getState) => {
    dispatch(setAccreditationsCountryFilter(countryFilter))
    let groupId = getCurrentGroup(getState());
    dispatch(fetchGetAccreditationsForReview(groupId, null, true, countryFilter));
    dispatch(fetchGetAccreditationsPerDomainRejectedByValidators(groupId, countryFilter));
    dispatch(clearAccreditationsDomainFilter());
}
export const onUpdateAccreditationsCountryFilterRejectedByApplicants = (countryFilter) => (dispatch, getState) => {
    dispatch(setAccreditationsCountryFilter(countryFilter))
    let groupId = getCurrentGroup(getState());
    dispatch(fetchGetAccreditationsForReview(groupId, null, false, countryFilter));
    dispatch(fetchGetAccreditationsPerDomainRejectedByApplicants(groupId, countryFilter));
    dispatch(clearAccreditationsDomainFilter());
}

export const onFetchGetAccreditationsPerDomainForValidation = (groupId) => (dispatch, getState) => {
    let countryFilter = getAccreditationsCountryFilter(getState());
    dispatch(fetchGetAccreditationsPerDomainForValidation(groupId, countryFilter));
}

export const onFetchGetAccreditationsPerDomainRejectedByValidators = (groupId) => (dispatch, getState) => {
    let countryFilter = getAccreditationsCountryFilter(getState());
    dispatch(fetchGetAccreditationsPerDomainRejectedByValidators(groupId, countryFilter));
}

export const onFetchGetAccreditationsPerDomainRejectedByApplicants = (groupId) => (dispatch, getState) => {
    let countryFilter = getAccreditationsCountryFilter(getState());
    dispatch(fetchGetAccreditationsPerDomainRejectedByApplicants(groupId, countryFilter));
}

export const fetchGetAccreditationsPerDomainFailed = createAction('FETCH_GET_ACCREDITATIONS_PER_DOMAIN_FAILED');
export const fetchGetAccreditationsPerDomainSuccess = createAction('FETCH_GET_ACCREDITATIONS_PER_DOMAIN_SUCCESS');
export const fetchGetAccreditationsPerDomainForValidation = createAction(
    'FETCH_GET_ACCREDITATIONS_PER_DOMAIN',
    (groupId, countryCode) => Api.getStaticsticsForAccreditationsForValidation(groupId, countryCode, 'DOMAIN'),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationsPerDomainSuccess,
        onFail: fetchGetAccreditationsPerDomainFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetAccreditationsPerDomainRejectedByValidators = createAction(
    'FETCH_GET_ACCREDITATIONS_PER_DOMAIN',
    (groupId, countryCode) => Api.getStatisticsForRejectedAccreditations(groupId, true, countryCode, 'DOMAIN'),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationsPerDomainSuccess,
        onFail: fetchGetAccreditationsPerDomainFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);
export const fetchGetAccreditationsPerDomainRejectedByApplicants = createAction(
    'FETCH_GET_ACCREDITATIONS_PER_DOMAIN',
    (groupId, countryCode) => Api.getStatisticsForRejectedAccreditations(groupId, false, countryCode, 'DOMAIN'),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationsPerDomainSuccess,
        onFail: fetchGetAccreditationsPerDomainFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setAccreditationsDomainFilter = createAction('SET_ACCREDITATIONS_DOMAIN_FILTER');
export const clearAccreditationsDomainFilter = createAction('CLEAR_ACCREDITATIONS_DOMAIN_FILTER');
export const onUpdateAccreditationsDomainFilterForValidation = (domain) => (dispatch, getState) => {
    dispatch(setAccreditationsDomainFilter(domain))
    let groupId = getCurrentGroup(getState());
    let countryFilter = getAccreditationsCountryFilter(getState());
    dispatch(fetchGetAccreditationsForValidation(groupId, countryFilter, domain));
}
export const onUpdateAccreditationsDomainFilterRejectedByValidators = (domain) => (dispatch, getState) => {
    dispatch(setAccreditationsDomainFilter(domain))
    let groupId = getCurrentGroup(getState());
    let countryFilter = getAccreditationsCountryFilter(getState());
    dispatch(fetchGetAccreditationsForReview(groupId, null, true, countryFilter, domain));
}
export const onUpdateAccreditationsDomainFilterRejectedByApplicants = (domain) => (dispatch, getState) => {
    dispatch(setAccreditationsDomainFilter(domain))
    let groupId = getCurrentGroup(getState());
    let countryFilter = getAccreditationsCountryFilter(getState());
    dispatch(fetchGetAccreditationsForReview(groupId, null, false, countryFilter, domain));
}

//- State
const initialState = {
    data: null,
    error: null,
    fetching: false,
    currentAccreditationIndex: null,
    validated: 0,
    currentPage: null,
    totalPages: null,
    leftNumber: null,
    rejectedBy: REJECTED_BY_VALIDATORS,
    loadingManagedOrgs: false,
    managedOrgs: null,
    requestsPerCountry: null,
    fetchingRequestsPerCountry: false,
    countryFilter: null,
    requestsPerDomain: null,
    fetchingRequestsPerDomain: false,
    domainFilter: null,
};

//- Reducers
export default handleActions({

    FETCH_GET_ACCREDITATIONS: (state) => {
        return {...state, data: null, currentPage: null, totalPages: null, leftNumber: null, error: null, fetching: true};
    },
    FETCH_GET_ACCREDITATIONS_FAILED: (state, action) => {
        return {...state, data: null, currentPage: null, totalPages: null, error: action.payload, fetching: false};
    },
    FETCH_GET_ACCREDITATIONS_SUCCESS: (state, action) => {
        return {...state, data: action.payload.content, currentPage: action.payload.number, totalPages: action.payload.totalPages, leftNumber: action.payload.totalElements, error: null, fetching: false};
    },
    SET_START_ACCREDITATION: (state, action) => {
        return {...state, currentAccreditationIndex: action.payload}
    },
    SET_NEXT_AS_START_ACCREDITATION: (state, action) => {
        return {...state, currentAccreditationIndex: action.payload}
    },
    CLEAN_VALIDATED_STATUS: (state) => {
        return {...state, validated: 0}
    },
    CLEAN_START_ACCREDITATION: (state) => {
        return {...state, currentAccreditationIndex: null}
    },
    NUMBER_OF_VALIDATED_ACCREDITATIONS_INCREMENT: (state) => {
        return {...state, validated: state.validated + 1}
    },
    ACCREDITATION_GROUP_LIST_RESET: (state) => {
        return {...state, data: null}
    },
    REJECTED_BY_SET: (state, action) => {
        return {...state, rejectedBy: action.payload}
    },
    FETCH_GET_MANAGED_ORGS: (state) => {
        return {...state, loadingManagedOrgs: true};
    },
    FETCH_GET_MANAGED_ORGS_SUCCESS: (state, action) => {
        return {...state, managedOrgs: action.payload.content, loadingManagedOrgs: false};
    },
    FETCH_GET_MANAGED_ORGS_FAILED: (state) => {
        return {...state, managedOrgs: null, loadingManagedOrgs: false};
    },
    FETCH_GET_ACCREDITATIONS_PER_COUNTRY: (state) => {
        return { ...state, requestsPerCountry: null, error: null, fetchingRequestsPerCountry: true };
    },
    FETCH_GET_ACCREDITATIONS_PER_COUNTRY_FAILED: (state, action) => {
        return { ...state, requestsPerCountry: null, error: action.payload, fetchingRequestsPerCountry: false };
    },
    FETCH_GET_ACCREDITATIONS_PER_COUNTRY_SUCCESS: (state, action) => {
        return { ...state, requestsPerCountry: action.payload, error: null, fetchingRequestsPerCountry: false };
    },
    SET_ACCREDITATIONS_COUNTRY_FILTER: (state, action) => {
        return {...state, countryFilter: action.payload}
    },
    CLEAR_ACCREDITATIONS_COUNTRY_FILTER: (state) => {
        return {...state, countryFilter: null}
    },
    FETCH_GET_ACCREDITATIONS_PER_DOMAIN: (state) => {
        return { ...state, requestsPerDomain: null, error: null, fetchingRequestsPerDomain: true };
    },
    FETCH_GET_ACCREDITATIONS_PER_DOMAIN_FAILED: (state, action) => {
        return { ...state, requestsPerDomain: null, error: action.payload, fetchingRequestsPerDomain: false };
    },
    FETCH_GET_ACCREDITATIONS_PER_DOMAIN_SUCCESS: (state, action) => {
        return { ...state, requestsPerDomain: action.payload, error: null, fetchingRequestsPerDomain: false };
    },
    SET_ACCREDITATIONS_DOMAIN_FILTER: (state, action) => {
        return {...state, domainFilter: action.payload}
    },
    CLEAR_ACCREDITATIONS_DOMAIN_FILTER: (state) => {
        return {...state, domainFilter: null}
    },
    CLEAR_MANAGED_ORGS: (state) => {
        return {...state, managedOrgs: null};
    }

}, initialState);

//- Selectors
export const getAccreditations = state => state.accreditations;

export const getAccreditationsData = state => getAccreditations(state).data;

export const getCurrentPageForAccreditationsList = state => getAccreditations(state).currentPage;

export const getTotalPagesForAccreditationsList = state => getAccreditations(state).totalPages;

export const getLeftAccreditationsNumber = state => getAccreditations(state).leftNumber;

export const loadingAccreditationList = state => getAccreditations(state).fetching;

export const getCurrentAccreditationIndex = state => getAccreditations(state).currentAccreditationIndex;

export const getStartAccreditationIndex = state => getAccreditations(state).startIndex;

export const getRejectedBy = state => getAccreditations(state).rejectedBy;

export const getNumberOfValidatedAccreditations = state => getAccreditations(state).validated;

export const getAccreditationDataByIndex = (state, index) => {
    let data = getAccreditationsData(state);

    if (_.isNil(data) || _.isNil(index) || index < 0 || index > (data.length - 1)) {
        return null;
    } else {
        return data[index];
    }
};

export const getAccreditationDataFormatted = (state) => {
    let index = getCurrentAccreditationIndex(state);

    let data = getAccreditationDataByIndex(state, index);
    if (_.isNil(data) || !_.has(data, 'accreditationData.titles') || !_.has(data, 'verifiedIdentity')) {
        return null;
    }

    let managedOrgs = getManagedOrgsData(state);
    let managingOrg = managedOrgs ? _.find(managedOrgs, org => org.domain === data.orgDomain) : null;

    // TODO: fix warning with empty ("") email "A component is changing a controlled input of type email to be uncontrolled."
    let accreditationData = {
        titleOrig: data.accreditationData.titles.original,
        titleEn: data.accreditationData.titles.en,
        titlesAdditional: {},
        dateIssued: moment(data.accreditationData.issuedAt),
        level: data.accreditationData.level,
        personFirstName: data.verifiedIdentity.firstName,
        personLastName: data.verifiedIdentity.lastName,
        personNationalId: data.verifiedIdentity.nationalId,
        email: data.email || "",
        personCountry: data.verifiedIdentity.countryCode,
        orgId: managingOrg ? managingOrg.id : null,
        orgContinent: getContinentByCountry(data.orgCountryCode, state),
        orgCountry: data.orgCountryCode,
        orgDomain: data.orgDomain,
        fieldErrors: data.answer ? data.answer.fieldErrors : null
    };

    let additionalTitles = _.pickBy((data.accreditationData.titles), (value, key) => {
        return key !== 'en' && key !== 'original';
    });

    _.mapValues(additionalTitles, (value, key) => {
        accreditationData.titlesAdditional[key] = value;
    });

    return accreditationData;
};

export const getAccreditationAnswer = (state) => {
    let index = getCurrentAccreditationIndex(state);

    let data = getAccreditationDataByIndex(state, index);

    if (_.isNil(data) || _.isNil(data.answer)) {
        return null;
    }

    if (_.isNil(data.answer.fieldErrors)) {
        data.answer.fieldErrors = {};
    } else if (_.has(data.answer.fieldErrors, 'orgCountry.value')) {
        data.answer.fieldErrors = {
            ...data.answer.fieldErrors,
            orgContinent: {value: getContinentByCountry(data.answer.fieldErrors.orgCountry.value, state)}
        }
    }

    return data.answer;
};

export const getAccreditationsList = state => {
    if (_.isNil(getAccreditationsData(state))) {
        return null;
    }

    return _.map(getAccreditationsData(state), data => ({
            id: data.id,
            title: data.accreditationData.titles.original,
            date: moment(data.accreditationData.issuedAt).format("L"),
            level: data.accreditationData.level,
            applicantName: data.verifiedIdentity.firstName + " " + data.verifiedIdentity.lastName,
            location: data.verifiedIdentity.countryCode,
        })
    );
};

export const getCurrentAccreditationGroupId = state => {
    let index = getCurrentAccreditationIndex(state);
    let data = getAccreditationDataByIndex(state, index);

    if (!_.isNil(data)) {
        return data.accreditationGroupId;
    }
};

export const getCurrentAccreditationId = state => {
    let index = getCurrentAccreditationIndex(state);
    let data = getAccreditationDataByIndex(state, index);
    if (!_.isNil(data)) {
        return data.id;
    }
};

export const getAccreditationIndexById = (state, id) => {
    let accreditationsList = getAccreditationsList(state);

    if (_.isNil(accreditationsList)) {
        return null;
    }

    let index = _.findIndex(accreditationsList, (elem) => {
        return elem.id === id;
    });

    if (index < 0) {
        return null;
    } else {
        return index;
    }
};

export const loadingManagedOrgs = state => getAccreditations(state).loadingManagedOrgs;

export const getManagedOrgsData = state => getAccreditations(state).managedOrgs;

export const getManagedOrgsOptions = state => {
    let managedOrgs = getManagedOrgsData(state);

    if (_.isNil(managedOrgs)) {
        return [];
    }

    return _.map(managedOrgs, org => ({
        value: org.id,
        label: `${org.name} (${org.domain})`,
        countryCode: org.address.countryCode
    }))
}

export const getAccreditationsPerCountryData = state => getAccreditations(state).requestsPerCountry;

export const loadingAccreditationsPerCountryData = state => getAccreditations(state).fetchingRequestsPerCountry;

export const getAccreditationsCountryFilter = state => getAccreditations(state).countryFilter;

export const getAccreditationsDomainFilter = state => getAccreditations(state).domainFilter;

export const getAccreditationsPerDomainData = state => getAccreditations(state).requestsPerDomain;

export const getAccreditationRequestsPerContinentData = state => {
    let countryData = getAccreditationsPerCountryData(state);
    if (_.isNil(countryData)) {
        return null;
    }

    let locationData = getLocationData(state);
    let continentData = _.mapValues(locationData, (value, key) => ({value: key, count: 0}));

    _.forEach(countryData, el => {
        let continent = _.findKey(locationData, countries => countries.includes(el.value));
        continentData[continent].count += el.count;
    });

    return _.values(continentData);
};



// WEBPACK FOOTER //
// ./src/reducers/accreditation/accreditations.js